import { ChipDenomination } from 'game-logic';
import { BlackjackAssetType } from '../../model/blackjack-types';
import { GameServices } from '../../services/game-services';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { assertNever } from 'src/games/common/helper';
import { GameAsset } from 'src/games/common/phaser/game/model/game-asset.type';

export class MiniChipViewModel {
  public get currentChipAsset(): GameAsset<BlackjackAssetType> {
    return this.gameServices.assetCatalogueService.getAsset(this.assetType(this.currentChip.value));
  }
  public get chipAsset$(): Observable<GameAsset<BlackjackAssetType>> {
    return this.currentChip.pipe(
      map((chipValue) =>
        this.gameServices.assetCatalogueService.getAsset(this.assetType(chipValue)),
      ),
    );
  }
  public get showDoubleNow(): boolean {
    return this.showDouble.getValue();
  }
  public get showDouble$(): Observable<boolean> {
    return this.showDouble.asObservable();
  }

  private readonly currentChip: BehaviorSubject<ChipDenomination>;
  private readonly showDouble: BehaviorSubject<boolean>;

  constructor(private gameServices: GameServices) {
    this.currentChip = new BehaviorSubject<ChipDenomination>(ChipDenomination.Chip10);
    this.showDouble = new BehaviorSubject<boolean>(false);
  }

  public setChipValue(chipValue: ChipDenomination): void {
    this.currentChip.next(chipValue);
  }

  public showDoubleChips(showDouble: boolean): void {
    this.showDouble.next(showDouble);
  }

  private assetType(chipValue: ChipDenomination): BlackjackAssetType {
    switch (chipValue) {
      case ChipDenomination.Chip10:
        return BlackjackAssetType.ChipSmall10;
      case ChipDenomination.Chip50:
        return BlackjackAssetType.ChipSmall50;
      case ChipDenomination.Chip100:
        return BlackjackAssetType.ChipSmall100;
      case ChipDenomination.Chip500:
        return BlackjackAssetType.ChipSmall500;
      case ChipDenomination.Chip1k:
        return BlackjackAssetType.ChipSmall1k;
      case ChipDenomination.Chip5k:
        return BlackjackAssetType.ChipSmall5k;
      case ChipDenomination.Chip10k:
        return BlackjackAssetType.ChipSmall10k;
      case ChipDenomination.Chip50k:
        return BlackjackAssetType.ChipSmall50k;
      case ChipDenomination.Chip100k:
        return BlackjackAssetType.ChipSmall100k;
      default:
        assertNever(chipValue, 'Invalid chip denomination');
    }
  }
}
